export const STORAGE_KEYS = {
  ACC_TOKEN: "accToken",
  RF_TOKEN: "rfToken",
  USER: "user",
  REMEMBER_ME: "rememberMe",
  ROLE: "role",
  EDIT: "isEditing",
  PREV_USER: "prevUser",
  // MFA "trust this device" token — sent back on future /authorize calls to
  // skip the code-entry screen on this device within its trust window.
  DEVICE_TRUST_TOKEN: "deviceTrustToken",
};

export const QUERY_PARAMS_KEY = {
  REDIRECT_URI: "redirect_URI",
  CLIENT_ID: "client_id",
  ROLE: "role",
  TOKEN: "token",
  EDIT: "edit",
  CANCEL_URI: "cancel",
  ACC_TOKEN: "access_token",
  USER_TYPE: "user_type",
};
